import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

// Original Shopify CDN images — square format, display perfectly
const products = [{
  img: 'https://cdn.shopify.com/s/files/1/0708/2174/0632/files/Professional_digital_product_202604140148_87e8dc11-4378-4f59-b2ad-a48e9c0cb3d5.jpg?v=1776341574',
  name: 'Blindaje Profesional ARCA 2026',
  tagline: '8 capítulos · Plan 30 días · Checklist ARCA',
  price: '$29.900',
  oldPrice: '$79.900',
  discount: '63%',
  url: 'https://digital-solvex-ar.myshopify.com/cart/48566663807233:1',
  accent: '#C8932A'
}, {
  img: 'https://cdn.shopify.com/s/files/1/0708/2174/0632/files/Premium_spreadsheet_software_202604140208.jpg?v=1776341573',
  name: 'Excel Maestro Argentina',
  tagline: '6 pestañas auto · Dashboard · Monitor ARCA',
  price: '$15.900',
  oldPrice: '$39.900',
  discount: '60%',
  url: 'https://digital-solvex-ar.myshopify.com/cart/48566664724737:1',
  accent: '#1E9B8A'
}, {
  img: 'https://cdn.shopify.com/s/files/1/0815/5253/9905/files/A_premium_online_202604161737.jpg?v=1776375500',
  name: 'Masterclass Freelancer Global',
  tagline: '6 módulos · Plataformas · Plan 90 días',
  price: '$36.900',
  oldPrice: '$99.900',
  discount: '63%',
  url: 'https://digital-solvex-ar.myshopify.com/cart/48566691037441:1',
  accent: '#1E9B8A'
}];
export function IndividualProducts() {
  return <section className="bg-cream py-16 md:py-24 px-4" data-id="element-135">
      <div className="max-w-5xl mx-auto" data-id="element-136">

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-137">
          <h2 className="font-display text-3xl md:text-4xl text-navy-mid mb-3 leading-tight" data-id="element-138">
            ¿Preferís empezar con un solo producto?
          </h2>
          <p className="text-gray-500 text-sm md:text-base" data-id="element-139">
            El Kit Completo es siempre la mejor opción, pero estos productos también están disponibles por separado.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-3 gap-5" data-id="element-140">
          {products.map((p, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.1
        }} className="bg-white rounded-2xl overflow-hidden shadow-md border border-gray-100 flex flex-col" data-id="element-141">
              {/* Square image — aspect-square ensures full display */}
              <div className="relative w-full" style={{
            aspectRatio: '1/1',
            overflow: 'hidden'
          }} data-id="element-142">
                <img src={p.img} alt={p.name} style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
              display: 'block'
            }} data-id="element-143" />
                {/* Gradient overlay */}
                <div className="absolute inset-0 pointer-events-none" style={{
              background: 'linear-gradient(to top, rgba(0,0,0,0.45) 0%, transparent 50%)'
            }} data-id="element-144" />
                {/* Discount badge */}
                <div className="absolute top-3 right-3 bg-red-500 text-white text-[10px] font-extrabold px-2 py-1 rounded-full" data-id="element-145">
                  -{p.discount} OFF
                </div>
              </div>

              {/* Content */}
              <div className="p-5 flex flex-col flex-grow" data-id="element-146">
                <p className="text-[10px] font-bold tracking-widest uppercase mb-2" style={{
              color: p.accent
            }} data-id="element-147">
                  {p.tagline}
                </p>
                <h3 className="font-display text-base md:text-lg text-navy-mid mb-4 leading-snug flex-grow" data-id="element-148">
                  {p.name}
                </h3>

                <div className="flex items-baseline gap-2 mb-4" data-id="element-149">
                  <span className="text-gray-300 text-sm line-through" data-id="element-150">{p.oldPrice}</span>
                  <span className="font-display text-2xl md:text-3xl text-navy-mid" data-id="element-151">
                    {p.price}
                  </span>
                </div>

                <a href={p.url} className="btn-gold flex items-center justify-center gap-2 font-bold text-sm py-3 px-4 rounded-xl no-underline" data-id="element-152">
                  Comprar ahora
                  <ArrowRight className="w-4 h-4 flex-shrink-0" data-id="element-153" />
                </a>
              </div>
            </motion.div>)}
        </div>

        {/* Kit upsell banner */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="mt-8 bg-navy-mid rounded-2xl p-5 md:p-7 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-154">
          <div data-id="element-155">
            <p className="font-display text-white text-lg md:text-xl mb-1" data-id="element-156">
              ¿O llevate los 5 por $62.900?
            </p>
            <p className="text-white/45 text-sm" data-id="element-157">
              Ahorrás $216.600 vs comprarlos por separado. Acceso inmediato a todo.
            </p>
          </div>
          <a href="https://digital-solvex-ar.myshopify.com/cart/48566694772993:1" className="btn-gold flex-shrink-0 flex items-center gap-2 font-bold text-sm md:text-base py-3.5 px-7 rounded-xl no-underline whitespace-nowrap" data-id="element-158">
            Ver Kit Completo →
          </a>
        </motion.div>

      </div>
    </section>;
}